import { memo, useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import AmenityInfoComponent from './AmenityInfoComponent';

import { confirmAction, getAmenity, removeAmenity } from './actions';

import AmenityInfoSkeleton from '../Shared/skeletons/AmenitySkeleton';

const AmenityInfoContainer = (props) => {
  const {
    selectedAmenity,
    onLoad,
    preselectedAmenityId,
    timezoneName,
    buildingType,
    onConfirmRemoveAmenity,
    match,
  } = props;

  useEffect(() => {
    onLoad();
  }, []);

  const onRemoveAmenity = (id, name, upcomingReservationsCount) => {
    const bodyText =
      upcomingReservationsCount > 0 ? (
        <span>
          There are <b>{upcomingReservationsCount}</b> existing reservations on{' '}
          <b>{name}</b>. If you delete <b>{name}</b>, it will automatically
          cancel all existing reservations. Are you certain <b>{name}</b> should
          be deleted?
        </span>
      ) : (
        <span>
          Are you certain <b>{name}</b> should be deleted?
        </span>
      );

    return onConfirmRemoveAmenity(bodyText, { id }, removeAmenity);
  };

  if (!selectedAmenity?.id) return <AmenityInfoSkeleton />;
  return (
    <AmenityInfoComponent
      {...selectedAmenity}
      timezoneName={timezoneName}
      preselectedAmenityId={preselectedAmenityId}
      buildingType={buildingType}
      onRemoveAmenity={onRemoveAmenity}
      match={match}
    />
  );
};

AmenityInfoContainer.defaultProps = {
  selectedAmenity: null,
  preselectedAmenityId: null,
  timezoneName: '',
  buildingType: '',
};

AmenityInfoContainer.propTypes = {
  selectedAmenity: PropTypes.shape({
    id: PropTypes.number,
  }),
  onLoad: PropTypes.func.isRequired,
  preselectedAmenityId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  timezoneName: PropTypes.string,
  buildingType: PropTypes.string,
  onConfirmRemoveAmenity: PropTypes.func.isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ amenity, buildings }, ownProps) => {
  const preselectedAmenityId = ownProps?.amenityId;
  const amenityId = preselectedAmenityId ?? ownProps?.match?.params?.id;
  const selectedAmenity = amenityId && amenity?.details?.[amenityId]?.data;
  const timezoneName = selectedAmenity?.timezone;
  const buildingId = selectedAmenity?.building?.id;
  const buildingType = buildingId && buildings?.[buildingId]?.type;
  return {
    amenityId,
    selectedAmenity,
    preselectedAmenityId,
    timezoneName,
    buildingType,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const preselectedAmenityId = ownProps?.amenityId;
  const amenityId = ownProps?.match?.params?.id;
  return {
    onLoad: () => !preselectedAmenityId && getAmenity(dispatch, amenityId),
    onConfirmRemoveAmenity: (bodyText, data, callback) =>
      confirmAction(dispatch, bodyText, data, callback),
  };
};

export default memo(
  connect(mapStateToProps, mapDispatchToProps)(AmenityInfoContainer),
);
